var _excluded = ["size"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
var FamilyGraphicIcon = function FamilyGraphicIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 48 : _props$size,
    otherProps = _objectWithoutProperties(props, _excluded);
  var iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "FAMILY-GRAPHIC-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: iconFill,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.605 9.657a4.334 4.334 0 012.39 3.663l.006.213v2.3a.5.5 0 01-.41.493l-.09.008-1.093-.001-.711 5.697a.5.5 0 01-.414.43l-.082.008h-3.067a.5.5 0 01-.48-.357l-.016-.081-.192-1.534a.5.5 0 01.973-.212l.019.088.137 1.095h2.184l.712-5.695a.5.5 0 01.414-.432l.083-.006L23 15.333v-1.8a3.334 3.334 0 00-1.658-2.882l-.185-.1a3.334 3.334 0 00-3.49.316.5.5 0 11-.6-.8 4.334 4.334 0 014.537-.41zm-14.672.41a.5.5 0 01-.6.8 3.334 3.334 0 00-5.328 2.457l-.006.21-.001 1.799h1.034a.5.5 0 01.48.358l.017.08.711 5.696h2.184l.138-1.095a.5.5 0 01.468-.437l.09.003a.5.5 0 01.438.468l-.004.09-.192 1.534a.5.5 0 01-.414.43l-.082.008H2.8a.5.5 0 01-.479-.357l-.017-.081-.712-5.697H.499a.5.5 0 01-.492-.41l-.008-.09v-2.3a4.334 4.334 0 016.934-3.466zm12.734-8.535a3.567 3.567 0 110 7.134 3.567 3.567 0 010-7.134zm-15.334 0a3.567 3.567 0 110 7.134 3.567 3.567 0 010-7.134zm15.334 1a2.567 2.567 0 100 5.134 2.567 2.567 0 000-5.134zm-15.334 0a2.567 2.567 0 100 5.134 2.567 2.567 0 000-5.134zM10.467 22.468a.5.5 0 01-.471-.331l-.023-.087-.697-4.183h-1.11a.5.5 0 01-.492-.41l-.008-.09V16.6a4.334 4.334 0 018.663-.21l.005.21v.767a.5.5 0 01-.41.492l-.09.008h-1.111l-.696 4.183a.5.5 0 01-.404.41l-.09.008h-3.066zm2.643-1.001l.697-4.182a.5.5 0 01.403-.41l.09-.008h1.033V16.6a3.334 3.334 0 00-3.15-3.328L12 13.267a3.334 3.334 0 00-3.329 3.15l-.005.183v.267H9.7a.5.5 0 01.47.33l.023.088.696 4.182h2.221zM12 6.133a2.8 2.8 0 110 5.6 2.8 2.8 0 010-5.6zm0 1a1.8 1.8 0 100 3.6 1.8 1.8 0 000-3.6z"
  })));
};
FamilyGraphicIcon.displayName = "FamilyGraphicIcon";
FamilyGraphicIcon.displayName = "FamilyGraphicIcon";
FamilyGraphicIcon.iconName = "Family";
export default FamilyGraphicIcon;